<template><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
     y="0px"
     viewBox="0 0 380 360" style="enable-background:new 0 0 380 360;" xml:space="preserve">
<g id="colorchange" class="color-change">
	<g>
		<path class="st0" d="M358.8,43.8L342,27h-81.3l-13.4-13.4H132.8L119.3,27H38L21.2,43.8H4v277.7h15.8L43.4,335H118l13.4-13.4h117.1
			L262,335h74.6l23.5-13.4H376V43.8H358.8z"/>
	</g>
</g>
</svg>
</template>